function getFromLocalStorage(perm) {
  const clientSideItems = localStorage.getItem('clientSideItem');
  if (!clientSideItems || clientSideItems == 'undefined') {
    return false;
  }
  const clientSideItemsSplited = clientSideItems.split(",");
  if(!clientSideItemsSplited || clientSideItemsSplited.length<=0){
    return false;
  }

  let check = [];
  check = clientSideItemsSplited.map((item) => item === perm);

  return check.includes(true);
}

/**
 * Bir sayfaya erisim yetkisi var mi? Karsilastirma main.ts'teki yonlendirme muhafizi ile ayni:
 * urlItem listesindeki adlar '_page' soneki olmadan saklaniyor.
 *
 * urlItem = SAYFA erisimi (route), clientSideItem = AKSIYON yetkisi (yukaridaki authXxx'ler).
 * Yetkisi olmayan bir sayfaya link gostermek kullaniciyi /401'e dusuruyor, bu yuzden linki
 * basmadan once bunu sormak gerekiyor.
 */
export function hasPageAccess(pageAuthItem) {
  const urlItems = localStorage.getItem('urlItem');
  if (!urlItems || urlItems == 'undefined') {
    return false;
  }

  return urlItems.split(',').some((item) => `${item}_page` === pageAuthItem);
}

export function authIncidentSave() {
  return getFromLocalStorage('Incident.Save');
}

export function authWorkOrderSave() {
  return getFromLocalStorage('WorkOrder.Save');
}

export function authWorkOrderDelete() {
  return getFromLocalStorage('WorkOrder.Delete');
}

export function authIncidentDelete() {
  return getFromLocalStorage('Incident.Delete');
}
